var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Manages the pergola damage type selection during claim declaration.
 * touches: pergola external damage declaration flow, damage type question.
 * invariants: the selected damage type syncs with the PergolaDamage entity through updateExternalDamage and remains subject to field validation.
 * inputs: PergolaDamage entity, damage type choices, validation helpers inherited from ExternalDamageComponent.
 * outputs: updates the pergola damageType, renders the translated question, choices and validation feedback.
 * see: ExternalDamageComponent, PergolaConstants
 */
import Component from 'vue-class-component';
import { UiCard } from '@claims-ia/design-system';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { PERGOLA_DAMAGE_TYPES_CHOICES } from '@shared/constants/externalDamages/PergolaConstants';
let PergolaDamageType = class PergolaDamageType extends ExternalDamageComponent {
    constructor() {
        super(...arguments);
        this.damageTypesChoices = PERGOLA_DAMAGE_TYPES_CHOICES;
        this.isSaving = false;
    }
    get damageType() {
        var _a;
        return (_a = this.externalDamage.damageType) !== null && _a !== void 0 ? _a : null;
    }
    set damageType(damageType) {
        this.updateExternalDamage({ damageType });
    }
};
PergolaDamageType = __decorate([
    Component({
        components: { RadioPrimaryButton, UiCard },
        props: {},
    })
], PergolaDamageType);
export default PergolaDamageType;
